import { CATEGORY_STYLE, type WebResource } from '@/content/resources';
import { typeScale } from '@/lib/typography';

type ResourceTileProps = {
  resource: WebResource;
  widthClass?: string;
  onOpen?: () => void;
  badge?: string;
};

export function ResourceTile({ resource, widthClass = 'w-[200px]', onOpen, badge }: ResourceTileProps) {
  const fallback = CATEGORY_STYLE[resource.category];
  const background = resource.backgroundColor || fallback.background;
  const accent = resource.textColor || fallback.text;
  const titleColor = resource.nameColor || '#1E1E1E';
  return (
    <a
      href={resource.href}
      onClick={onOpen}
      className={`relative block h-[110px] shrink-0 overflow-hidden rounded-xl px-3.5 py-3 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus:ring-4 focus:ring-[#399918]/20 ${widthClass}`}
      style={{ background, color: accent }}
    >
      <p className={`${typeScale.cardCategory} opacity-80`}>
        {resource.cardCategory || resource.category}
      </p>
      <h3 className={`mt-2 line-clamp-2 ${typeScale.cardTitle}`} style={{ color: titleColor }}>
        {resource.title}
      </h3>
      {resource.subtitle ? (
        <p className={`mt-0.5 line-clamp-1 opacity-80 ${typeScale.cardSubtitle}`}>{resource.subtitle}</p>
      ) : null}
      {badge ? (
        <span className={`absolute top-2.5 right-2.5 rounded-full bg-white/80 px-2 py-0.5 uppercase tracking-wide text-hmong-ink ${typeScale.cardBadge}`}>
          {badge}
        </span>
      ) : null}
      {resource.premium ? (
        <span className={`absolute bottom-2.5 right-2.5 inline-flex items-center gap-1 rounded-full bg-white/75 px-2 py-0.5 text-[#8a5b00] ${typeScale.cardBadge}`}>
          <span aria-hidden>🔒</span>
          Premium
        </span>
      ) : null}
    </a>
  );
}
